import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../hooks/useTheme'
import CartIcon from './CartIcon'

interface SimpleHeaderProps {
  title: string
  subtitle?: string
  showBackButton?: boolean
}

const SimpleHeader: React.FC<SimpleHeaderProps> = ({
  title,
  subtitle,
  showBackButton = true
}) => {
  const navigate = useNavigate()
  const { colors } = useTheme()

  return (
    <header className="bg-white shadow-md border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: colors.primary }}>
              <span className="text-2xl">🏕️</span>
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                {title}
              </h1>
              {subtitle && (
                <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {showBackButton && (
              <button
                onClick={() => {
                  navigate('/')
                  setTimeout(() => {
                    document.getElementById('espacios')?.scrollIntoView({ behavior: 'smooth' })
                  }, 100)
                }}
                style={{
                  borderColor: colors.primary,
                  color: colors.primary,
                  backgroundColor: `${colors.primary}10`
                }}
                className="border-2 font-semibold px-4 py-2 rounded-lg transition-all duration-200 hover:bg-opacity-20 flex items-center space-x-2 text-sm"
              >
                ← Volver al Inicio
              </button>
            )}
            <CartIcon />
          </div>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
